export default "__VITE_ASSET__BJ_ikbhD__"